export const localization = {
  au: 'Австралия (Australia)',
  at: 'Австрия (Austria)',
  az: 'Азербайджан (Azerbaijan)',
  ax: 'Аландские о-ва',
  al: 'Албания (Albania)',
  dz: 'Алжир (Algeria)',
  as: 'Американское Самоа',
  ai: 'Ангилья',
  ao: 'Ангола (Angola)',
  ad: 'Андорра (Andorra)',
  aq: 'Антарктида',
  ag: 'Антигуа и Барбуда (Antigua and Barbuda)',
  ar: 'Аргентина (Argentina)',
  am: 'Армения (Armenia)',
  aw: 'Аруба (Aruba)',
  af: 'Афганистан (Afghanistan)',
  bs: 'Багамы (Bahamas)',
  bd: 'Бангладеш (Bangladesh)',
  bb: 'Барбадос (Barbados)',
  bh: 'Бахрейн (Bahrain)',
  by: 'Беларусь (Belarus)',
  bz: 'Белиз (Belize)',
  be: 'Бельгия (Belgium)',
  bj: 'Бенин (Benin)',
  bm: 'Бермудские о-ва',
  bg: 'Болгария (Bulgaria)',
  bo: 'Боливия (Bolivia)',
  bq: 'Бонэйр, Синт-Эстатиус и Саба (Caribbean Netherlands)',
  ba: 'Босния и Герцеговина (Bosnia and Herzegovina)',
  bw: 'Ботсвана (Botswana)',
  br: 'Бразилия (Brazil)',
  io: 'Британская территория в Индийском океане (British Indian Ocean Territory)',
  bn: 'Бруней-Даруссалам (Brunei)',
  bf: 'Буркина-Фасо (Burkina Faso)',
  bi: 'Бурунди (Burundi)',
  bt: 'Бутан (Bhutan)',
  vu: 'Вануату (Vanuatu)',
  va: 'Ватикан (Vatican City)',
  gb: 'Великобритания (United Kingdom)',
  hu: 'Венгрия (Hungary)',
  ve: 'Венесуэла (Venezuela)',
  vg: 'Виргинские о-ва',
  vi: 'Виргинские о-ва',
  um: 'Внешние малые о-ва',
  tl: 'Восточный Тимор (Timor-Leste)',
  vn: 'Вьетнам (Vietnam)',
  ga: 'Габон (Gabon)',
  ht: 'Гаити (Haiti)',
  gy: 'Гайана (Guyana)',
  gm: 'Гамбия (Gambia)',
  gh: 'Гана (Ghana)',
  gp: 'Гваделупа (Guadeloupe)',
  gt: 'Гватемала (Guatemala)',
  gn: 'Гвинея (Guinea)',
  gw: 'Гвинея-Бисау (Guinea-Bissau)',
  de: 'Германия (Germany)',
  gg: 'Гернси',
  gi: 'Гибралтар',
  hn: 'Гондурас (Honduras)',
  hk: 'Гонконг (Hong Kong)',
  gd: 'Гренада (Grenada)',
  gl: 'Гренландия',
  gr: 'Греция (Greece)',
  ge: 'Грузия (Georgia)',
  gu: 'Гуам (Guam)',
  dk: 'Дания (Denmark)',
  je: 'Джерси',
  dj: 'Джибути (Djibouti)',
  dg: 'Диего-Гарсия',
  dm: 'Доминика (Dominica)',
  do: 'Доминиканская Республика (Dominican Republic)',
  eg: 'Египет (Egypt)',
  zm: 'Замбия (Zambia)',
  eh: 'Западная Сахара',
  zw: 'Зимбабве (Zimbabwe)',
  il: 'Израиль (Israel)',
  in: 'Индия (India)',
  id: 'Индонезия (Indonesia)',
  jo: 'Иордания (Jordan)',
  iq: 'Ирак (Iraq)',
  ir: 'Иран (Iran)',
  ie: 'Ирландия (Ireland)',
  is: 'Исландия (Iceland)',
  es: 'Испания (Spain)',
  it: 'Италия (Italy)',
  ye: 'Йемен (Yemen)',
  cv: 'Кабо-Верде (Cape Verde)',
  kz: 'Казахстан (Kazakhstan)',
  kh: 'Камбоджа (Cambodia)',
  cm: 'Камерун (Cameroon)',
  ca: 'Канада (Canada)',
  ic: 'Канарские о-ва',
  qa: 'Катар (Qatar)',
  ke: 'Кения (Kenya)',
  cy: 'Кипр (Cyprus)',
  kg: 'Киргизия (Kyrgyzstan)',
  ki: 'Кирибати (Kiribati)',
  cn: 'Китай (China)',
  kp: 'КНДР (North Korea)',
  cc: 'Кокосовые о-ва',
  co: 'Колумбия (Colombia)',
  km: 'Коморы (Comoros)',
  cg: 'Конго - Браззавиль (Congo)',
  cd: 'Конго - Киншаса (Congo)',
  xk: 'Косово (Kosovo)',
  cr: 'Коста-Рика (Costa Rica)',
  ci: 'Кот-д’Ивуар (Côte d’Ivoire)',
  cu: 'Куба (Cuba)',
  kw: 'Кувейт (Kuwait)',
  cw: 'Кюрасао (Curaçao)',
  la: 'Лаос (Laos)',
  lv: 'Латвия (Latvia)',
  ls: 'Лесото (Lesotho)',
  lr: 'Либерия (Liberia)',
  lb: 'Ливан (Lebanon)',
  ly: 'Ливия (Libya)',
  lt: 'Литва (Lithuania)',
  li: 'Лихтенштейн (Liechtenstein)',
  lu: 'Люксембург (Luxembourg)',
  mu: 'Маврикий (Mauritius)',
  mr: 'Мавритания (Mauritania)',
  mg: 'Мадагаскар (Madagascar)',
  yt: 'Майотта',
  mo: 'Макао (Macau)',
  mw: 'Малави (Malawi)',
  my: 'Малайзия (Malaysia)',
  ml: 'Мали (Mali)',
  mv: 'Мальдивы (Maldives)',
  mt: 'Мальта (Malta)',
  ma: 'Марокко (Morocco)',
  mq: 'Мартиника (Martinique)',
  mh: 'Маршалловы Острова (Marshall Islands)',
  mx: 'Мексика (Mexico)',
  mz: 'Мозамбик (Mozambique)',
  md: 'Молдова (Moldova)',
  mc: 'Монако (Monaco)',
  mn: 'Монголия (Mongolia)',
  ms: 'Монтсеррат',
  mm: 'Мьянма (Myanmar)',
  na: 'Намибия (Namibia)',
  nr: 'Науру (Nauru)',
  np: 'Непал (Nepal)',
  ne: 'Нигер (Niger)',
  ng: 'Нигерия (Nigeria)',
  nl: 'Нидерланды (Netherlands)',
  ni: 'Никарагуа (Nicaragua)',
  nu: 'Ниуэ',
  nz: 'Новая Зеландия (New Zealand)',
  nc: 'Новая Каледония (New Caledonia)',
  no: 'Норвегия (Norway)',
  ac: 'о-в Вознесения',
  im: 'о-в Мэн',
  nf: 'о-в Норфолк',
  cx: 'о-в Рождества',
  sh: 'о-в Св. Елены',
  pn: 'о-ва Питкэрн',
  tc: 'о-ва Тёркс и Кайкос',
  ae: 'ОАЭ (United Arab Emirates)',
  om: 'Оман (Oman)',
  ky: 'Острова Кайман',
  ck: 'Острова Кука',
  pk: 'Пакистан (Pakistan)',
  pw: 'Палау (Palau)',
  ps: 'Палестинские территории (Palestine)',
  pa: 'Панама (Panama)',
  pg: 'Папуа — Новая Гвинея (Papua New Guinea)',
  py: 'Парагвай (Paraguay)',
  pe: 'Перу (Peru)',
  pl: 'Польша (Poland)',
  pt: 'Португалия (Portugal)',
  pr: 'Пуэрто-Рико (Puerto Rico)',
  kr: 'Республика Корея (South Korea)',
  re: 'Реюньон (Réunion)',
  ru: 'Россия (Russia)',
  rw: 'Руанда (Rwanda)',
  ro: 'Румыния (Romania)',
  sv: 'Сальвадор (El Salvador)',
  ws: 'Самоа (Samoa)',
  sm: 'Сан-Марино (San Marino)',
  st: 'Сан-Томе и Принсипи (São Tomé and Príncipe)',
  sa: 'Саудовская Аравия (Saudi Arabia)',
  mk: 'Северная Македония (Macedonia)',
  mp: 'Северные Марианские о-ва',
  sc: 'Сейшельские Острова (Seychelles)',
  bl: 'Сен-Бартелеми',
  mf: 'Сен-Мартен',
  pm: 'Сен-Пьер и Микелон',
  sn: 'Сенегал (Senegal)',
  vc: 'Сент-Винсент и Гренадины (Saint Vincent and the Grenadines)',
  kn: 'Сент-Китс и Невис (Saint Kitts and Nevis)',
  lc: 'Сент-Люсия (Saint Lucia)',
  rs: 'Сербия (Serbia)',
  ea: 'Сеута и Мелилья',
  sg: 'Сингапур (Singapore)',
  sx: 'Синт-Мартен',
  sy: 'Сирия (Syria)',
  sk: 'Словакия (Slovakia)',
  si: 'Словения (Slovenia)',
  us: 'Соединенные Штаты (United States)',
  sb: 'Соломоновы Острова (Solomon Islands)',
  so: 'Сомали (Somalia)',
  sd: 'Судан (Sudan)',
  sr: 'Суринам (Suriname)',
  sl: 'Сьерра-Леоне (Sierra Leone)',
  tj: 'Таджикистан (Tajikistan)',
  th: 'Таиланд (Thailand)',
  tw: 'Тайвань (Taiwan)',
  tz: 'Танзания (Tanzania)',
  tg: 'Того (Togo)',
  tk: 'Токелау',
  to: 'Тонга (Tonga)',
  tt: 'Тринидад и Тобаго (Trinidad and Tobago)',
  ta: 'Тристан-да-Кунья',
  tv: 'Тувалу (Tuvalu)',
  tn: 'Тунис (Tunisia)',
  tm: 'Туркменистан (Turkmenistan)',
  tr: 'Турция (Turkey)',
  ug: 'Уганда (Uganda)',
  uz: 'Узбекистан (Uzbekistan)',
  ua: 'Украина (Ukraine)',
  wf: 'Уоллис и Футуна',
  uy: 'Уругвай (Uruguay)',
  fo: 'Фарерские о-ва',
  fm: 'Федеративные Штаты Микронезии (Micronesia)',
  fj: 'Фиджи (Fiji)',
  ph: 'Филиппины (Philippines)',
  fi: 'Финляндия (Finland)',
  fk: 'Фолклендские о-ва',
  fr: 'Франция (France)',
  gf: 'Французская Гвиана (French Guiana)',
  pf: 'Французская Полинезия (French Polynesia)',
  tf: 'Французские Южные территории',
  hr: 'Хорватия (Croatia)',
  cf: 'Центрально-Африканская Республика (Central African Republic)',
  td: 'Чад (Chad)',
  me: 'Черногория (Montenegro)',
  cz: 'Чехия (Czech Republic)',
  cl: 'Чили (Chile)',
  ch: 'Швейцария (Switzerland)',
  se: 'Швеция (Sweden)',
  sj: 'Шпицберген и Ян-Майен',
  lk: 'Шри-Ланка (Sri Lanka)',
  ec: 'Эквадор (Ecuador)',
  gq: 'Экваториальная Гвинея (Equatorial Guinea)',
  er: 'Эритрея (Eritrea)',
  sz: 'Эсватини (Swaziland)',
  ee: 'Эстония (Estonia)',
  et: 'Эфиопия (Ethiopia)',
  gs: 'Южная Георгия и Южные Сандвичевы о-ва',
  za: 'Южно-Африканская Республика (South Africa)',
  ss: 'Южный Судан (South Sudan)',
  jm: 'Ямайка (Jamaica)',
  jp: 'Япония (Japan)',
};
